export interface MenuItem {
  label: string;
  route: string;
  icon: string;
  roles?: string[];
}

export interface MenuGroup {
  label: string;
  icon: string;
  roles: string[];
  route?: string;
  children?: MenuItem[];
}

// Daily operations first; configuration and access controls last.
export const Menus: MenuGroup[] = [
  { label: 'Dashboard', icon: 'fa-solid fa-house', route: '/dashboard', roles: ['superadmin', 'store_manager'] },
  { label: 'Needs action', icon: 'fa-solid fa-triangle-exclamation', route: '/operations/needs-action', roles: ['superadmin', 'store_manager'] },
  {
    label: 'Orders',
    icon: 'fa-solid fa-bag-shopping',
    roles: ['store_manager', 'superadmin', 'picker'],
    children: [
      { label: 'All Orders', icon: 'fa-solid fa-list', route: '/orders', roles: ['store_manager', 'superadmin'] },
      { label: 'Order Lookup', icon: 'fa-solid fa-magnifying-glass', route: '/orders/lookup', roles: ['store_manager', 'superadmin'] },
      { label: 'Picking tasks', icon: 'fa-solid fa-box', route: '/operations/picking', roles: ['superadmin', 'store_manager', 'picker'] },
    ],
  },
  {
    label: 'Inventory',
    icon: 'fa-solid fa-warehouse',
    roles: ['store_manager', 'superadmin', 'inventory_operator'],
    children: [
      { label: 'Store Inventory', icon: 'fa-solid fa-box-open', route: '/inventory', roles: ['store_manager', 'superadmin'] },
      { label: 'Store Products', icon: 'fa-solid fa-store', route: '/inventory/store-products', roles: ['store_manager', 'superadmin'] },
      { label: 'Receive stock', icon: 'fa-solid fa-truck-ramp-box', route: '/inventory/receiving', roles: ['superadmin', 'store_manager', 'inventory_operator'] },
      { label: 'Stock Count', icon: 'fa-solid fa-clipboard-check', route: '/inventory/stock-count', roles: ['inventory_operator', 'store_manager', 'superadmin'] },
      { label: 'Suppliers & Purchases', icon: 'fa-solid fa-chart-line', route: '/inventory/intelligence', roles: ['store_manager', 'superadmin'] },
    ],
  },
  { label: 'Support Cases', icon: 'fa-solid fa-headset', route: '/operations/support', roles: ['superadmin', 'store_manager'] },
  {
    label: 'Riders',
    icon: 'fa-solid fa-motorcycle',
    roles: ['superadmin', 'store_manager'],
    children: [
      { label: 'Riders Fleet', icon: 'fa-solid fa-motorcycle', route: '/riders', roles: ['superadmin', 'store_manager'] },
      { label: 'Rider Verifications', icon: 'fa-solid fa-user-check', route: '/riders/verification', roles: ['superadmin', 'store_manager'] },
    ],
  },
  {
    label: 'Finance',
    icon: 'fa-solid fa-scale-balanced',
    roles: ['superadmin', 'finance'],
    children: [
      { label: 'Reconciliation', icon: 'fa-solid fa-list-check', route: '/finance/reconciliation', roles: ['superadmin', 'finance'] },
      { label: 'Refund Requests', icon: 'fa-solid fa-rotate-left', route: '/orders/refunds', roles: ['finance', 'superadmin'] },
      { label: 'Rider Payouts', icon: 'fa-solid fa-wallet', route: '/riders/payouts', roles: ['finance', 'superadmin'] },
      { label: 'Rider Wallets', icon: 'fa-solid fa-money-bill-transfer', route: '/riders/wallets', roles: ['finance', 'superadmin'] },
      { label: 'Payout Rules', icon: 'fa-solid fa-calculator', route: '/riders/payout-rules', roles: ['superadmin'] },
    ],
  },
  {
    label: 'Product Catalog',
    icon: 'fa-solid fa-boxes-stacked',
    roles: ['superadmin'],
    children: [
      { label: 'Product List', icon: 'fa-solid fa-box', route: '/products' },
      { label: 'Categories', icon: 'fa-solid fa-layer-group', route: '/categories' },
      { label: 'Brands', icon: 'fa-solid fa-tags', route: '/brands' },
    ],
  },
  {
    label: 'Stores',
    icon: 'fa-solid fa-store',
    roles: ['superadmin', 'store_manager'],
    children: [
      { label: 'Store List', icon: 'fa-solid fa-store', route: '/stores', roles: ['superadmin'] },
      { label: 'Store Weather', icon: 'fa-solid fa-cloud-sun-rain', route: '/stores/weather-management', roles: ['superadmin', 'store_manager'] },
      { label: 'Store Holidays', icon: 'fa-solid fa-calendar-xmark', route: '/stores/holidays', roles: ['superadmin', 'store_manager'] },
      { label: 'Cart Charges', icon: 'fa-solid fa-file-invoice-dollar', route: '/stores/charges', roles: ['superadmin'] },
    ],
  },
  {
    label: 'Marketing & Growth',
    icon: 'fa-solid fa-bullhorn',
    roles: ['superadmin', 'store_manager'],
    children: [
      { label: 'Promotions', icon: 'fa-solid fa-bolt', route: '/marketing/promotions', roles: ['superadmin', 'store_manager'] },
      { label: 'Promotion Analytics', icon: 'fa-solid fa-chart-pie', route: '/marketing/promotions/analytics', roles: ['superadmin', 'store_manager'] },
      { label: 'Promotion Usage', icon: 'fa-solid fa-receipt', route: '/marketing/promotions/usage', roles: ['superadmin', 'store_manager'] },
    ],
  },
  {
    label: 'Content',
    icon: 'fa-solid fa-panorama',
    roles: ['superadmin'],
    children: [
      { label: 'Home Layout CMS', icon: 'fa-solid fa-panorama', route: '/content/sections', roles: ['superadmin'] },
      { label: 'Collections', icon: 'fa-solid fa-layer-group', route: '/collections', roles: ['superadmin'] },
      { label: 'Dynamic Bottom Tab', icon: 'fa-solid fa-mobile-screen', route: '/dynamic-tabs', roles: ['superadmin'] },
    ],
  },
  {
    label: 'Reports',
    icon: 'fa-solid fa-chart-line',
    roles: ['superadmin', 'store_manager'],
    children: [
      { label: 'Sales Report', icon: 'fa-solid fa-file-invoice-dollar', route: '/reports/sales', roles: ['superadmin', 'store_manager'] },
      { label: 'Daily Orders', icon: 'fa-solid fa-calendar-day', route: '/reports/orders', roles: ['superadmin'] },
      { label: 'Daily Revenue', icon: 'fa-solid fa-sack-dollar', route: '/reports/revenue', roles: ['superadmin'] },
      { label: 'Top Products', icon: 'fa-solid fa-star', route: '/reports/products', roles: ['superadmin'] },
      { label: 'Store Performance', icon: 'fa-solid fa-store', route: '/reports/stores', roles: ['superadmin'] },
      { label: 'Rider Performance', icon: 'fa-solid fa-motorcycle', route: '/reports/riders', roles: ['superadmin'] },
      { label: 'Customer Analytics', icon: 'fa-solid fa-users-line', route: '/reports/customers', roles: ['superadmin'] },
      { label: 'Inventory Report', icon: 'fa-solid fa-boxes-stacked', route: '/reports/inventory', roles: ['superadmin'] },
      { label: 'Coupon Usage', icon: 'fa-solid fa-ticket', route: '/reports/coupons', roles: ['superadmin'] },
      { label: 'Payment Report', icon: 'fa-solid fa-credit-card', route: '/reports/payments', roles: ['superadmin'] },
      { label: 'Cancellation Report', icon: 'fa-solid fa-ban', route: '/reports/cancellations', roles: ['superadmin'] },
      { label: 'Search Analytics', icon: 'fa-solid fa-magnifying-glass-chart', route: '/reports/search', roles: ['superadmin'] },
    ],
  },
  {
    label: 'App Management',
    icon: 'fa-solid fa-mobile-screen-button',
    roles: ['superadmin'],
    children: [
      { label: 'Rider App', icon: 'fa-solid fa-motorcycle', route: '/app-management/rider-app' },
    ],
  },
  {
    label: 'Administration',
    icon: 'fa-solid fa-user-shield',
    roles: ['superadmin', 'finance'],
    children: [
      { label: 'Access Control', icon: 'fa-solid fa-user-shield', route: '/users', roles: ['superadmin'] },
      { label: 'Sensitive Audit', icon: 'fa-solid fa-clock-rotate-left', route: '/operations/audit', roles: ['superadmin'] },
      { label: 'Privileged Access', icon: 'fa-solid fa-lock', route: '/operations/access', roles: ['superadmin', 'finance'] },
    ],
  },
  { label: 'My account', icon: 'fa-solid fa-user', route: '/settings/account-details', roles: ['picker', 'inventory_operator', 'finance'] },
];
